import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
Vue.use(VueRouter)

// ==== tab 缓存 name 自动对齐 ====
// 背景：layout 的 keep-alive 以各 tab 的 componentName（即 $route.name）作为 include，
// 按【组件 name 选项】匹配缓存（约定见 routes.js 顶部注释：有 name 的才是缓存组件）。
// 历史页面大量存在"路由无 name + 组件无 name"（如 setting/user 等列表页），这些页面
// 从不被缓存，任何路由跳转（含关闭 tab 后 replace 到目标 tab）都会整页重建并重新拉取
// 数据——即"关闭一个 tab，焦点所在的 tab 立即刷新"。此处对未按约定配置的路由自动对齐：
// 路由补派生 name，组件注入同款 name，使已打开的 tab 均可命中缓存、恢复原状。
// 保护：同一组件被多个路由复用（如 add/edit 共用组件）时注入共享 name 会串态，
// 检测到复用即回滚注入，维持该组件"不缓存"的现状。
const componentOwner = new Map() // 组件对象 -> 首次注入的路由 name（用于检测多路由复用）

function deriveRouteName(path) {
  return 'rc-' + String(path).replace(/[^a-zA-Z0-9]/g, '-')
}

function alignComponentName(route) {
  const original = route.component
  if (typeof original !== 'function') {
    return
  }
  route.component = function () {
    return Promise.resolve(original()).then((mod) => {
      const comp = mod && mod.default ? mod.default : mod
      if (comp && typeof comp === 'object' && !comp.name && route.name) {
        const owner = componentOwner.get(comp)
        if (owner === undefined) {
          // 首个引用该组件的路由：注入 name，使 keep-alive include 可匹配
          componentOwner.set(comp, route.name)
          comp.name = route.name
        } else if (owner !== route.name) {
          // 同一组件被第二个路由复用：回滚注入（避免多路由共享缓存实例互相串态）
          if (comp.name === owner) {
            delete comp.name
          }
          componentOwner.set(comp, '__multi__')
        }
      }
      return mod
    })
  }
}

function decorateRoutes(list, parentPath) {
  (list || []).forEach((route) => {
    const fullPath = route.path
      ? parentPath
        ? parentPath.replace(/\/$/, '') + '/' + route.path.replace(/^\//, '')
        : route.path
      : parentPath
    if (!route.name && route.component) {
      // 无 name 且有页面组件的路由：补派生 name（$route.name 将作为 tab 的 componentName）
      route.name = deriveRouteName(fullPath)
    }
    if (route.children) {
      decorateRoutes(route.children, fullPath)
    }
    alignComponentName(route)
  })
}
decorateRoutes(routes)

const router = new VueRouter({
  routes
})


router.beforeEach((to, from, next) => {
  if (to.path === '/register' || to.path === '/login' || to.path === '/internRegister') {
    next();
    return;
  }

  const token = window.localStorage.getItem("token");

  if (!token) {
    if (from.path === "/login") {
      next(false);
    } else {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      });
    }
    return;
  }

  if (to.meta.isPublic) {
    next();
    return;
  }

  const menuList = window.localStorage.getItem("menuList");
  if (menuList) {
    const menus = JSON.parse(menuList);
    const res = menus.find((item) => to.path === item.path || to.path.startsWith(item.path + '/'));

    console.log('before each check menu', res)

    if (res) {
      next();
    } else {
      next("/403");
    }
  } else {
    console.log("local storage don't has menu list");
    next("/403");
  }

});

export default router
